import { getImputationsByDay } from "./imputationsActions";
import { getCurrentDate } from "../../time";

//FIXME: règle incompréhensible...
export function checkOverlappingOnlyDriving(/*data, onError*/) {
    /*let onlyDriving = true;
    for (let i = 0; i < data.length; i++) {
        if (!data[i].activity.driving && !data[i].in_progress) {
            onlyDriving = false;
            break;
        }
    }

    if (onlyDriving === false){
        onError("Le chevauchement est interdit");
        return true;
    }

    return false;*/
}

export async function checkOverlapping(imputation, forbidManyInProgressActivities) {
    let data = await getImputationsByDay(imputation.day_id);
    return getEventsOverlapping(data, imputation, forbidManyInProgressActivities).length > 0;
}

//Vérifie s'il y a chevauchement
//Return true si chevauchement
function getEventsOverlapping(array, event, forbidManyInProgressActivities) {
    let inBetween = [];
    let now = getCurrentDate(true);
    let maxTimeOfDay = new Date(getCurrentDate(true).setHours(23, 59, 0));
    let start = new Date(event.date_start);
    let end = event.in_progress ? maxTimeOfDay : new Date(event.date_end);

    array.forEach((currentImputation) => {
        if (event.id === currentImputation.id) return;

        let existingStartDate = new Date(currentImputation.date_start);
        let existingEndDate = new Date(currentImputation.date_end);

        if (currentImputation.in_progress) {
            if (start < existingStartDate) {
                existingEndDate = now;
            } else {
                existingEndDate = start;
            }
        }

        // b starts in a
        let existingStartsInNew = start <= existingStartDate && existingStartDate < end;
        // b ends in a
        let existingEndsInNew = false;

        //Au moins une activité qui n'est pas en cours
        let atLeastOneActivityNotInProgress = !currentImputation.in_progress || !event.in_progress;

        let manyInProgressActivitiesVerification = false;
        if (forbidManyInProgressActivities)
            manyInProgressActivitiesVerification = event.in_progress && currentImputation.in_progress;

        if (atLeastOneActivityNotInProgress) {
            existingEndsInNew = start < existingEndDate && existingEndDate <= end;
        }

        //Le nouvel event englobe l'existant
        let newIncludesExisting = start < existingStartDate && existingEndDate < end;
        //L'existant englobe le nouveau
        let existingIncludesNew = existingStartDate < start && end < existingEndDate;

        let sameInProgressActivityAlreadyExists = false;
        if (event.in_progress && currentImputation.in_progress) {
            if (start.getTime() === existingStartDate.getTime()) sameInProgressActivityAlreadyExists = true;
        }

        if (currentImputation.activity.end_of_day && (existingEndsInNew || existingIncludesNew)) {
            //Cas particulier où on a une ligne de fin de journée (de 15 min)
            //Et qu'on souhaite reprendre une activité avant la fin des 15 getMinutes
            //Dans ce cas ce n'est pas du chevauchement et MyOpen va réduire la durée
            //de cette ligne de fin de journée.
            //On vérifie que les dates de début ne sont pas la même car la réduction ne serait pas possible
            if (start !== existingStartDate) {
                existingEndsInNew = false;
                existingIncludesNew = false;
            }
        }

        if (
            existingStartsInNew ||
            existingEndsInNew ||
            newIncludesExisting ||
            existingIncludesNew ||
            manyInProgressActivitiesVerification ||
            sameInProgressActivityAlreadyExists
        )
            inBetween.push(currentImputation);
    });

    return inBetween;
}

export function numberOfDaysNotValidatedExceeded(startDate, dayToleranceHours, allDays, allImputations) {
    let exceeded = false;
    var BreakException = {};

    try {
        let limitDate = new Date(startDate);
        limitDate.setHours(limitDate.getHours() - dayToleranceHours);
        let oldImputations = allImputations.filter((x) => x.date_start < limitDate);
        oldImputations.sort((a, b) => {
            return a.date_end > b.date_end ? 1 : a.date_end < b.date_end ? -1 : 0;
        });
        const lastImputation = oldImputations[oldImputations.length - 1];
        if (lastImputation) {
            const day = allDays.find((d) => d.id === lastImputation.day_id);
            if (!day.validation) {
                exceeded = true;
            }
        }
    } catch (e) {
        if (e !== BreakException) throw e;
    }

    return exceeded;
}
